import { useSwaggerlessContext } from 'Context/SwaggerlessContext';
import React, { useEffect, useState } from 'react';
import { withHousehold } from 'Context/HouseholdContext';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import fr from 'facet-rest';
import useAffordance from 'Hooks/useAffordance';
import IncomeTaxSectionPicker from '../ResourceSections/IncomeTax/IncomeTaxSectionPicker';
import IncomeDetailsSectionPicker from '../ResourceSections/IncomeDetails/IncomeDetailsSectionPicker';

const IncomeDetailsLegacy = () => {
  const { householdResource } = useSimpleHousehold();
  const { getQuestionnaireAnswer } = useSwaggerlessContext();

  const {
    collection: clientCollection,
  } = useAffordance(householdResource.relationship(fr.relationships.clients.name).link('related'), {
    onlyRunOnMount: true,
  });

  const [maritalStatus, setMaritalStatus] = useState(null);

  useEffect(() => {
    if (!householdResource) {
      return;
    }
    getQuestionnaireAnswer(householdResource.id(), 'clientMaritalStatus')
      .then((res) => setMaritalStatus(res.attributes.value));
  }, [householdResource]);

  if (maritalStatus === null) {
    return null;
  }

  const primaryClientResource = clientCollection?.resources().list().find(c => c.attr('isPrimary') === 'true');
  const spouseClientResource = clientCollection?.resources().list().find(c => c.attr('isPrimary') !== 'true');

  return (
    <>
      {primaryClientResource ? <IncomeDetailsSectionPicker clientResource={primaryClientResource} /> : null}
      {spouseClientResource ? <IncomeDetailsSectionPicker clientResource={spouseClientResource} /> : null}
      {primaryClientResource ? <IncomeTaxSectionPicker clientResource={primaryClientResource} /> : null}
    </>
  );
};

IncomeDetailsLegacy.propTypes = {};

export default withHousehold(IncomeDetailsLegacy);
